/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
import React from "react";
import {
  AppBar,
  Box,
  Button,
  Icon,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import {
  EstadoProyecto,
} from "src/redux/api/types/proyectos";
import TablaBasica, {
  Iordenamiento,
  Ipaginador,
} from "src/components/tabla/TablaBasica";
import { boxCard } from "src/styles/styles";
import CargandoLista from "src/components/cargando/CargandoLista";
import CustomDialog from "src/components/dialogo/CustomDialog";
import { LoadingButton } from "@mui/lab";
import DetalleAspirante from "src/pages/gestion/aspirantes/detalle-aspitante/DetalleAspirante";
import { useAspirantes } from "./useAspirantes";
import FiltrosAspirantes from "./filtros/FiltrosAspirantes";
import AsingarGestor from "./asignar-gestor/AsingarGestor";
import DialogoConfirmacion from "src/components/dialogo/Confirmacion";

export interface ListadoProyectosProps {
  estadoProyectos: EstadoProyecto;
}

export const ListaAspirantes = ({ estadoProyectos }: ListadoProyectosProps) => {
  const {
    aspirantesResp,
    cargandoAspirantes,
    refrescandoAspirantes,
    pageIndex,
    pageSize,
    sortField,
    sortDirection,
    setPageIndex,
    setPageSize,
    setSortField,
    setSortDirection,
    columnasAspirantes,
    handleFiltrarProyectos,
    mostrarAsignacionUsuario,
    mostrarConfirmacionContratacion,
    setMostrarConfirmacionContratacion,
    setMostrarAsignacionUsuario,
    setAspiranteAintervenir,
    aspiranteAintervenir,
    handleAsignarUsuarioGestor,
    mostrarDetalleAspirante,
    setMostrarDetalleAspirante,
    handleGuardarVerificacion,
    handleMarcarComoContratado
  } = useAspirantes("", "");

  const paginador: Ipaginador = {
    pagina: pageIndex,
    rowsPerPage: pageSize,
    setPagina: setPageIndex,
    setRowsPerPage: setPageSize,
    total: aspirantesResp?.total || 0,
  };

  const ordenamiento: Iordenamiento = {
    sortField,
    sortDirection,
    setSortField,
    setSortDirection,
  };
  

  return (
    <Box sx={boxCard}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 2,
          width: "100%",
        }}
      >
        <FiltrosAspirantes onFilter={handleFiltrarProyectos} />
      </Box>
      {(cargandoAspirantes || refrescandoAspirantes || !aspirantesResp) && (
        <CargandoLista />
      )}
      {(!cargandoAspirantes && !refrescandoAspirantes && aspirantesResp) && <TablaBasica
        datos={aspirantesResp?.result ?? []}
        paginador={paginador}
        ordenamiento={ordenamiento}
        columnas={columnasAspirantes}
        itemId="personaNaturalId"
      />}
      <CustomDialog
        mostrar={mostrarAsignacionUsuario}
        onClose={() => {
          setAspiranteAintervenir(undefined);
          setMostrarAsignacionUsuario(false);
        }}
        contenido={
          <AsingarGestor
            onSubmit={handleAsignarUsuarioGestor}
            aspirante={aspiranteAintervenir}
          />
        }
        acciones={
          <>
            <Button
              onClick={() => {
                setMostrarAsignacionUsuario(false);
                setAspiranteAintervenir(undefined);
              }}
            >
              Cancelar
            </Button>
            <LoadingButton
              variant="contained"
              color="primary"
              sx={{ color: "white" }}
              type="submit"
              data-testid="btn-nuevo-maestro"
              form="form-asignar-gestor"
            >
              Guardar
            </LoadingButton>
          </>
        }
        titulo={`Asignar gestor a ${aspiranteAintervenir?.nombres} ${aspiranteAintervenir?.apellidos}`}
        tamanioMaximo="md"
        fullWidth
      />
      <CustomDialog
        mostrar={mostrarDetalleAspirante}
        onClose={() => {
          setAspiranteAintervenir(undefined);
          setMostrarDetalleAspirante(false);
        }}
        contenido={
          <DetalleAspirante
            onSubmit={handleGuardarVerificacion}
            onClose={() => {
              setAspiranteAintervenir(undefined);
              setMostrarDetalleAspirante(false);
            }}
            aspirante={aspiranteAintervenir}
          />
        }
        acciones={
          <>
            <Button
              onClick={() => {
                setMostrarDetalleAspirante(false);
                setAspiranteAintervenir(undefined);
              }}
            >
              Cancelar
            </Button>
            <LoadingButton
              variant="contained"
              color="primary"
              sx={{ color: "white" }}
              type="submit"
              data-testid="btn-nuevo-maestro"
              form="form-verificacion"
            >
              Guardar
            </LoadingButton>
          </>
        }
        header={
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {aspiranteAintervenir?.nombres} {aspiranteAintervenir?.apellidos}
              </Typography>

              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setMostrarDetalleAspirante(false)}
                aria-label="close"
              >
                <Icon>close</Icon>
              </IconButton>
            </Toolbar>
          </AppBar>
        }
        tamanioMaximo="xl"
        fullWidth
        pantallaCompleta
      />

<DialogoConfirmacion
        mostrarConfirmacion={mostrarConfirmacionContratacion}
        setMostrarConfirmacion={setMostrarConfirmacionContratacion}
        titulo="Confirmación"
        mensaje="¿Está seguro que desea cambiar el estado del aspirante a CONTRATADO?"
        onConfirmar={handleMarcarComoContratado}
      />
    </Box>
  );
};
